import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectors, sliceKeys } from '../../../model';

const StateContext = createContext();
const ActionContext = createContext();

const { selectHouses } = selectors[sliceKeys.houses];

const ParentRoomProvider = ({ children }) => {
  const [parent, setParent] = useState();

  const houses = useSelector(selectHouses);

  useEffect(() => {
    setParent();
  }, [houses]);

  return (
    <StateContext.Provider value={parent}>
      <ActionContext.Provider value={setParent}>
        {children}
      </ActionContext.Provider>
    </StateContext.Provider>
  );
};

const useParentRoom = () => useContext(StateContext);
const useSetParentRoom = () => useContext(ActionContext);

export { ParentRoomProvider, useParentRoom, useSetParentRoom };
